<template>
    <div>
        <div class="app-info" v-if="personalInfo.personalInformation">
            <div>
                <div class="app-info-row">
                    <div class="app-info-group">
                        <label for="lastName">Last name</label>
                        <span for="lastNameText">{{ personalInfo.personalInformation.lastName }}</span>
                    </div>
                    <div class="app-info-group">
                        <label for="firstName">First name</label>
                        <span for="firstNameText">{{ personalInfo.personalInformation.firstName }}</span>
                    </div>
                    <div class="app-info-group">
                        <label for="middleName">Middle name</label>
                        <span for="middleNameText">{{ personalInfo.personalInformation.middleName ? personalInfo.personalInformation.middleName : ' ' }}</span>
                    </div>
                    <div class="app-info-group">
                        <label for="suffix">Suffix</label>
                        <span for="suffixText">{{ personalInfo.personalInformation.suffix ? personalInfo.personalInformation.suffix : ' ' }}</span>
                    </div>
                    <div class="app-info-group">
                        <label for="dateOfBirth">Date of birth</label>
                        <span for="dateOfBirthText">{{ personalInfo.personalInformation.dateOfBirth }}</span>
                    </div>
                    <div class="app-info-group">
                        <label for="gender">Gender</label>
                        <span for="genderText">{{ personalInfo.credentialInformation.gender }}</span>
                    </div>
                </div>
                <div class="app-info-row" v-if="personalInfo.personalInformation.physicalAddress">
                    <div class="info-box">
                        <div class="user-info">
                            <span class="user-address-info">Physical address</span>
                            <span>{{ personalInfo.personalInformation.physicalAddress.addressLine1 }}</span>
                            <span>{{ personalInfo.personalInformation.physicalAddress.addressLine2 }}</span>
                            <span>
                                {{ personalInfo.personalInformation.physicalAddress.city }},
                                {{
 personalInfo.personalInformation.physicalAddress.addressType == 'Us Domestic'?
                                personalInfo.personalInformation.physicalAddress.state :
                                personalInfo.personalInformation.physicalAddress.province
                                }},
                                {{ personalInfo.personalInformation.physicalAddress.country }}
                            </span>
                            <span>
                                {{
 personalInfo.personalInformation.physicalAddress.addressType == 'Us Domestic' ?
                                personalInfo.personalInformation.physicalAddress.zipPlus == '' ?  personalInfo.personalInformation.physicalAddress.zipCode :
                                `${personalInfo.personalInformation.physicalAddress.zipCode} - ${personalInfo.personalInformation.physicalAddress.zipPlus}`
                                : `${personalInfo.personalInformation.physicalAddress.internationalZipCode}`
                                }}
                            </span>

                            <div v-if="mfaType!=4">
                                <router-link :to="{ name: 'UpdateAddress' }">Update my address</router-link>
                            </div>
                        </div>
                        <div class="user-info">
                            <span class="user-address-info">Mailing address</span>
                            <span>{{ personalInfo.personalInformation.mailingAddress.addressLine1 }} </span>
                            <span>{{ personalInfo.personalInformation.mailingAddress.addressLine2 }}</span>
                            <span>
                                {{ personalInfo.personalInformation.mailingAddress.city }},
                                {{
 personalInfo.personalInformation.mailingAddress.addressType == 'Us Domestic'?
                                personalInfo.personalInformation.mailingAddress.state :
                                personalInfo.personalInformation.mailingAddress.province
                                }},
                                {{ personalInfo.personalInformation.mailingAddress.country }}
                            </span>
                            <span>
                                {{
 personalInfo.personalInformation.mailingAddress.addressType == 'Us Domestic' ?
                                personalInfo.personalInformation.mailingAddress.zipPlus == '' ?  personalInfo.personalInformation.mailingAddress.zipCode :
                                `${personalInfo.personalInformation.mailingAddress.zipCode} - ${personalInfo.personalInformation.mailingAddress.zipPlus}`
                                : `${personalInfo.personalInformation.mailingAddress.internationalZipCode}`
                                }}
                            </span>
                        </div>
                        <div class="user-info">
                            <span class="contact-info">Contact information</span>
                            <div class="verify-email">
                                <span class="user-info-email">{{ personalInfo.personalInformation.email ? personalInfo.personalInformation.email : 'No email on file' }}</span>
                                <img v-if="personalInfo.personalInformation.isEmailVerified == true" class="verify-icon" src="static/verified-icon.png" alt="Email is verified">
                            </div>
                            <div class="verify-phone">
                                <span>{{ personalInfo.personalInformation.phone ? personalInfo.personalInformation.phone : 'No phone on file' }}</span>
                                <img v-if="personalInfo.personalInformation.isPhoneVerified == true" class="verify-icon" src="static/verified-icon.png" alt="Phone is verified">
                            </div>
                            <div v-if="mfaType!=4">
                                <router-link :to="{ name: 'UpdateContacts' }">Update / Verify my contact information</router-link>
                            </div>
                        </div>
                        <div class="user-info">
                            <label for="donor">Organ donor</label>
                            <span for="donorText">{{ personalInfo.credentialInformation.organDonor }}</span>
                        </div>
                    </div>
                </div>
                <div>
                    <div class="res-display">
                        <span class="res-notification">Upcoming DMV Reservations</span>
                        <input type="image" src="static/RefreshBtn.png" class="refresh-icon app-tooltip" tabindex="0"
                               alt="Click Refresh to view updated reservation information"
                               v-tooltip="'Click Refresh to view updated reservation information'" @click="getPersonalProfileInformation()" />
                    </div>
                    <div class="upcoming-res">
                        <div class="app-info-row app-reservations" v-if="personalInfo.reservationInformation && personalInfo.reservationInformation.length > 0">
                            <div class="user-reservations" v-for="(reservationInformation, i) in personalInfo.reservationInformation" :key="i">
                                <div class="app-info-group user-res-details">
                                    <span class="res-details">Service</span>
                                    <span>{{ reservationInformation.visitType }}</span>
                                </div>
                                <div class="app-info-group user-res-details">
                                    <span class="res-details">Confirmation number</span>
                                    <span>{{ reservationInformation.appointmentNumber }}</span>
                                </div>
                                <div class="app-info-group user-res-details">
                                    <span class="res-details">Date and time</span>
                                    <span>{{ reservationInformation.scheduleDate | formatWeekday }}</span>
                                    <span>{{ reservationInformation.scheduleDate | formatMonthDayYear }}</span>
                                    <span>{{ reservationInformation.scheduleTime | formatTime }}</span>
                                </div>
                                <div class="app-info-group user-res-details">
                                    <span class="res-details">Location</span>
                                    <span>{{ reservationInformation.location }}</span>
                                </div>
                                <a href="javascript: void(0)" @click="modifyReservation(reservationInformation.appointmentNumber)">Modify / Cancel Reservation </a>
                            </div>
                        </div>
                        <div class="no-reservation" v-else>
                            <span>No upcoming reservation(s) to show.</span>
                        </div>
                    </div>
                </div>
                <div class="app-notice app-info-row" v-if="personalInfo.blocksInformation.length > 0">
                    <div class="blocks-info"><img class="active-icon" src="static/activeBlocks.svg" alt="Icon" /> <b>You have the following block(s):</b> </div>
                    <ul>
                        <li v-for="(item, p) in personalInfo.blocksInformation" :key="`action${p}`">
                            {{ item.actionInstruction }}
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import { mapGetters,mapActions } from 'vuex'
import * as COMMONS from '../../store/_commons';
export default {
    name : 'ProfileInfo',

    data () {
        return {
          onlineToken: ''
        }
    },
    watch: {
      onlineToken(value) {
        console.log('Update value for data', value)
        window.close();
      },
      onlineTokenLocalStorage(value) {
        console.log('UPDATE VALUE for computed', value)
        window.close();
      }
    },
    computed: {
        ...mapGetters({
            personalInfo: COMMONS.GUEST_PERSONAL_INFO,
        }),
        mfaType() {
            return this.$store.state.guestLogin.mfaType;
        },
        onlineTokenLocalStorage() {
            return localStorage.getItem('onlineToken');
        }
    },
    mounted() {
    },
    methods: {
        ...mapActions({
            getPersonalProfileInformation: COMMONS.GUEST_PROFILE,
        }),
        blocksInfo(url) {
            window.open(url, '_blank');

        },

        modifyReservation(appointmentNumber) {
            // let activeUserData = {
            //     'onlineToken': encodeURIComponent(this.$store.state.guestLogin.accessToken),
            //     'activeUser': true
            // }
            // localStorage.setItem('activeUserData', activeUserData);
            localStorage.setItem('confirmationNumber', appointmentNumber)
            localStorage.setItem('onlineToken', encodeURIComponent(this.$store.state.guestLogin.accessToken))
            // window.open('http://localhost:8081/lookup')
            this.onlineToken = localStorage.getItem('onlineToken');
            // window.open(`http://ridmvwebtest-dev.ri.gov/lookup?confirmationNumber=${appointmentNumber}&&onlineToken=${this.onlineToken}`)
            window.open(`${window.config.WEB_CLIENT_URL}lookup?confirmationNumber=${appointmentNumber}&&onlineToken=${this.onlineToken}`)
        },
    },
    destroyed() {
        localStorage.removeItem('onlineToken');
        localStorage.removeItem('confirmationNumber');
    }
}

</script>

<style scoped lang="scss">
.app-info {
    border-bottom: 1px solid var(--ri-gray);
    span, label {
        font-size: 1rem;
    }
    .app-notice {
        --whitespace: 1.5em;
        margin-bottom: var(--whitespace);
        max-width: 100%;
        p:first-child {
            @extend %font-sans-bold;
        }
        ul {
          li {
            list-style: initial;
            margin-bottom: calc(var(--whitespace) * 0.5);
          }
        }
        @supports (margin-block: 1em) {
          margin-block-end: var(--whitespace);
          ul {
            margin-inline-start: var(--whitespace);
            li {
              margin-block-end: calc(var(--whitespace) * 0.5);
            }
          }
        }
    }
    .res-display{
        display: flex;
        align-items: center;
    }
    .upcoming-res{
        margin-top: 1rem;
        .no-reservation{
            margin-bottom: 0.5rem;
        }
    }
    .app-reservations {
        display: block;
        .user-reservations{
            display: flex;
            flex-wrap: wrap;
            margin-top: 0.5rem;
            margin-bottom: 0.5rem;
        }
    }
    .res-notification{
        font-weight: bold;
    }
    .refresh-icon{
        margin-left: 10px;
        width: 100px;
        height: 30px;
    }
}
.app-info-row {
    display: flex;
    flex-wrap: wrap;
    gap: 1% 3%;
    .app-info-group {
        min-width: 150px;
        width: 14%;
        margin-bottom: 1.5rem;
        span {
            display: block;
            word-wrap: break-word;
        }
    }
    .user-res-details{
        min-width: 190px;
        margin-bottom: 0.5rem;

        .res-details {
            font-weight: bold;
            margin-bottom: 0.5rem;
        }
    }
}
@media only screen and (max-width: 600px) {
    .app-info-row {
        display: block;
        .user-res-details{
            min-width: 275px;
        }
    }
}
@media only screen and (max-width: 800px) {
    .active-icon {
        width: 25px;
        height: 25px;
        vertical-align: middle;
    }
    .blocks-info {
        margin-bottom: 1rem;
        margin-left: 0rem !important;
    }
    .app-notice{
        ul {
            li {
                margin-left: 1rem;
            }
        }
    }
}
.info-box {
    display: flex;
    flex-wrap: wrap;
    gap: 1rem 3%;
    width: 100%;
    margin: 1rem auto;
    box-sizing: border-box;
    margin-bottom: 2rem;
    .user-info {
        width: 31%;
        word-wrap: break-word;    
        .user-address-info, .contact-info {
            font-weight: 600;
        }
        span {
            display: block;
            line-height: 30px;
        }
        h2 {
            font-size: 1.25rem;
        }   
        .user-info-sub-row {
            display: flex;
            gap: 1rem 3rem;
            flex-wrap: wrap;
        } 
        .verify-phone, .verify-email{
            display: flex;
            flex-wrap: wrap;
            .verify-icon{
                margin-left: 5px;
                width: 50px;
                height: 20px;
            }
            .user-info-email{
                display: block;
                width: 100%;
            }

        }
    }
    @media only screen and (max-width: 600px) {
        .user-info {
            width: 100%;     
            .user-info-sub-row {
                display: block;
                .organ-donor {
                    padding-top: 10px;
                }
            } 
            .verify-phone, .verify-email{
                .verify-icon{
                    width: 50px;
                    height: 20px;
                }
            }
        }  
    }

    @media only screen and (min-width: 610px) and (max-width: 950px) {
        .user-info {  
            .verify-phone, .verify-email{
                .verify-icon{
                    width: 50px;
                    height: 20px;
                }
            }
        }  
    }
}
.active-icon {
    width: 25px;
    height: 25px;
    vertical-align: middle;
}
.blocks-info {
    margin-bottom: 1rem;
    margin-left: -1rem;
}

.app-link-open {
    cursor: pointer;
    color: var(--ri-blue);
    &:focus {
        outline-color: #ff8e47;
    }
}

</style>